export const siteInfo = {
  brand: '剧真档案',
  brandEn: 'JUZHEN ARCHIVE',
  slogan: '看爆料短剧前，先分清哪段是真的',
  intro:
    '剧真档案是一个专注爆料短剧的内容对照库。我们把每部剧的取材来源、原型人物、改编程度和片尾声明拆开来看，再用真实爆料逐条比对，让你自己判断哪些是还原，哪些是加工。',
  email: 'contact@juzhen-dangan.example.com',
  workTime: '每周一至周五 10:00—18:00 整理与回复',
  since: '2024',
};

export const heroStats = [
  { value: '186', label: '已归档短剧', suffix: '部' },
  { value: '1,240', label: '对照条目', suffix: '条' },
  { value: '92', label: '片尾声明解读', suffix: '篇' },
  { value: '6', label: '题材分区', suffix: '类' },
];

export const tickerTopics = [
  '真实事件改编确认',
  '剧情原型人物梳理',
  '改编程度量化',
  '与真实爆料逐条对比',
  '片尾声明逐句解读',
  '取证与信源标注',
  '题材分区检索',
  '观众判断力',
];

export const dimensionsOverview = [
  {
    icon: 'ri-shield-check-line',
    title: '真实事件改编确认',
    desc: '先回答最关键的一件事——这部剧到底有没有原型。我们逐条核对片尾声明措辞、公开报道与信源等级，给出「已确认改编 / 高度疑似 / 部分取材 / 声明存疑」四种判定。',
    points: ['片尾声明原文留档', '公开报道交叉核对', '信源等级标注'],
  },
  {
    icon: 'ri-user-search-line',
    title: '剧情原型人物梳理',
    desc: '剧中的名字几乎都不是真名。我们把主要角色与原型身份对应起来，标明哪些是单一个体、哪些是多人合并，避免把剧里的人物直接当成现实里的某个人。',
    points: ['角色—原型对照表', '合并与强化标注', '化名处理说明'],
  },
  {
    icon: 'ri-scales-3-line',
    title: '改编程度分析',
    desc: '还原不是一句「像不像」。我们拆成事件框架、人物贴合、时间线、生活细节、程序严谨五个维度分别打分，让「改编程度」变成可以比较的数字。',
    points: ['五维评分体系', '评分依据可追溯', '同题材横向对比'],
  },
  {
    icon: 'ri-file-list-3-line',
    title: '与真实爆料对比',
    desc: '把宣传语换成对照表。同一个情节，真实情况是怎样、剧里改成怎样，一栏一栏列出来，戏剧强化与合理补白分开说明。',
    points: ['逐条双栏对比', '补白 vs 虚构区分', '结局提纯提示'],
  },
];

export const methodSteps = [
  {
    no: '01',
    title: '先看片尾声明',
    desc: '「改编自真实事件」「取材于社会新闻」「剧情为虚构创作」——三种措辞的法律含义完全不同，这是判断的第一步。',
  },
  {
    no: '02',
    title: '再找一手信源',
    desc: '优先看官方通报与实名报道，其次是多家媒体交叉印证。只有单一自媒体来源的，我们会标注为待核实。',
  },
  {
    no: '03',
    title: '拆出原型人物',
    desc: '把剧中角色逐个对应到现实身份，标注是单一原型还是多人合并，这决定了能不能「对号入座」。',
  },
  {
    no: '04',
    title: '给改编程度打分',
    desc: '按五个维度分别评估，重点看戏剧冲突是否被放大、结局是否被提纯、程序是否被简化。',
  },
  {
    no: '05',
    title: '输出对照记录',
    desc: '把以上结果整理成一页可检索的档案，标明核对日期，后续有新信源会同步更新。',
  },
];

export const faqs = [
  {
    q: '片尾写「改编自真实事件」就等于剧情都是真的吗？',
    a: '不等于。这句话只确认取材于真实事件，通常紧接着还会有「人物姓名已作处理」「部分情节为艺术创作」等限定。真实的是事件的性质与主干，角色姓名、对白、具体冲突多数经过加工，不能逐条当成事实。',
  },
  {
    q: '剧里的主角能对应到现实中的具体某个人吗？',
    a: '一般不能。爆料短剧出于隐私与法律风险考虑，普遍会做化名、合并与地域模糊处理。我们会在每个角色的对照说明里标出它属于单一个体还是多人合并，遇到合并形象就不要对号入座。',
  },
  {
    q: '你们怎么判断一部剧的改编程度？',
    a: '我们使用五个维度打分：事件框架还原度、人物原型贴合度、时间线准确度、生活细节真实度与法律程序严谨度。每项都有对应的依据说明，最终给出一个 0—100 的综合分，方便同题材横向比较。',
  },
  {
    q: '「取材于社会新闻」和「根据真实事件改编」有什么区别？',
    a: '后者指向相对明确的具体事件，前者范围更宽，只表示灵感来自真实报道，并不承诺哪段是还原的。措辞越模糊，虚构空间通常越大，这是我们在判定时会重点看的地方。',
  },
  {
    q: '档案里的信息会更新吗？',
    a: '会。我们会标注核对日期，一旦出现新的公开报道或官方通报，会重新评估对应条目并更新判定与评分。信源不足的条目会被标记为待核实，而不是直接下结论。',
  },
  {
    q: '我没有看剧，可以只看对照结论吗？',
    a: '可以。每部剧的档案页都把「真实事件」和「剧情节选」分开呈现，你可以只看结论部分了解事件本身。不过涉及剧透的内容我们不做隐藏，介意的话建议看完再读。',
  },
];

export const testimonials = [
  {
    name: '林一舟',
    role: '短剧爱好者',
    quote:
      '以前看完一部剧总觉得心里没底，不知道哪些是真的。现在先来这边对一遍，再看剧，感觉完全不一样了。',
  },
  {
    name: '陈默',
    role: '内容从业者',
    quote:
      '改编程度那五个维度挺实在的，我们做选题的时候会参考，至少不会把戏剧冲突当成事实写进稿子里。',
  },
  {
    name: '周晚',
    role: '高校在读',
    quote:
      '片尾声明解读那部分最有意思，原来那几句话不是随便写的，措辞差别真的会影响到能不能对号入座。',
  },
  {
    name: '何向',
    role: '法律从业者',
    quote:
      '声明措辞和程序严谨度这两块做得比较克制，没有过度断言，这一点在同类内容里不多见。',
  },
];

export const principles = [
  {
    icon: 'ri-link-m',
    title: '信源优先，不做断言',
    desc: '每条结论都附信源等级。只有单一来源或无法交叉印证的内容，我们标注为待核实，而不是替读者下结论。',
  },
  {
    icon: 'ri-user-unfollow-line',
    title: '不指向真实个人',
    desc: '我们只梳理角色与原型的对应关系，不披露当事人真实身份信息，也不鼓励对号入座。',
  },
  {
    icon: 'ri-eye-line',
    title: '加工与补白分开写',
    desc: '为了叙事连贯而做的合理补白，和纯粹为了冲突而添加的虚构情节，在我们这里是两种不同的标注。',
  },
  {
    icon: 'ri-refresh-line',
    title: '记录会更新',
    desc: '每条档案标注核对日期。出现新通报或新报道时，我们会重新评估并公开修改，而不是悄悄替换结论。',
  },
];

export const sourceLevels = [
  {
    level: 'A 级',
    type: '官方通报 / 司法文书 / 权威机构发布',
    usage: '可直接作为事件事实引用，并在档案中标注来源类型。',
  },
  {
    level: 'B 级',
    type: '实名记者的调查报道 / 机构媒体原创',
    usage: '需两家以上独立媒体交叉印证后，方可用于事件框架判定。',
  },
  {
    level: 'C 级',
    type: '自媒体转述 / 未署名整理',
    usage: '仅用于发现线索，会标注「待核实」，不进入结论性判定。',
  },
  {
    level: 'D 级',
    type: '匿名爆料 / 无法追溯出处',
    usage: '不作为档案依据，最多用于提示后续核对方向。',
  },
];

export const aboutVoices = [
  {
    name: '许知白',
    role: '影视编导',
    quote: '改编程度那套打分我给同事安利过，做宣传物料时至少不会把戏剧桥段写成事实。',
  },
  {
    name: '穆一',
    role: '自由撰稿人',
    quote: '信源分级这块很实用，写稿引用前先看等级，能少踩很多坑。',
  },
  {
    name: '宋砚',
    role: '中学教师',
    quote: '带学生做媒介素养的讨论时，用你们的对照表讲得很清楚，比空讲概念有效。',
  },
];

export const aboutTimeline = [
  { time: '2024 年', title: '从一份表格式笔记开始', desc: '最初只是几个人看完剧后随手记录的对照片段，用来提醒自己别把剧情当新闻。' },
  { time: '2025 年', title: '拆出五个评估维度', desc: '记录越来越多之后，我们把「像不像」拆成可比较的五个维度，让结论可以被复核。' },
  { time: '2026 年', title: '开放检索与线索征集', desc: '档案库上线检索与题材分区，并开始接受读者提供的核对线索，持续更新判定。' },
];